import React, { useState, useEffect, useCallback, memo } from 'react';
import { useSelector } from 'react-redux';
import {
  Box,
  Icon,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core';

import { convertObjToArr } from '../../../../utils';
import useStyles from './styles';

import CircleChart from '../../../../components/CircleChart';

const Module = props => {
  const classes = useStyles();
  const { children, id, description, collapse } = props;
  const [expand, setExpand] = useState(false);
  const { list: coursesList, current } = useSelector(state => state.course);
  const [lessonsModule, setLessonsModule] = useState([]);
  const [lessonsModuleCompleted, setLessonsModuleCompleted] = useState([]);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    const courseLessons = coursesList[current.course]?.lessons;
    if (!courseLessons) return;
    const courseLessonsArr = convertObjToArr(courseLessons);
    if (current.lesson) {
      setIsActive(courseLessons[current.lesson].moduleId === Number(id));
    }
    setLessonsModule(
      courseLessonsArr.filter(lesson => Number(lesson.moduleId) === Number(id)),
    );
  }, [coursesList, current, id]);

  useEffect(() => {
    const courseLessons = coursesList[current.course]?.lessons;
    if (current.lesson && courseLessons && current.lesson in courseLessons) {
      setIsActive(courseLessons[current.lesson].moduleId === Number(id));
    }
  }, [coursesList, current, id]);

  useEffect(() => {
    if (lessonsModule.length) {
      setLessonsModuleCompleted(
        lessonsModule.filter(l => l.isConcluded).length,
      );
    } else {
      setLessonsModuleCompleted(0);
    }
  }, [lessonsModule]);

  const handleGetProgress = useCallback(
    type => {
      switch (type) {
        case 'percentage':
          return lessonsModule.length > 0
            ? (lessonsModuleCompleted / lessonsModule.length) * 100
            : 0;
        case 'phrase':
          return lessonsModule.length > 0
            ? `${lessonsModule.length} aula${
                lessonsModule.length > 1 ? 's' : ''
              }`
            : 'Sem aulas';
        default:
          return lessonsModule.length;
      }
    },
    [lessonsModule.length, lessonsModuleCompleted],
  );

  const handleToggleExpand = useCallback(() => {
    setExpand(oldExpand => !oldExpand);
  }, []);

  useEffect(() => {
    setExpand(collapse ? false : isActive);
  }, [collapse, isActive]);

  useEffect(() => {
    setExpand(isActive);
  }, [isActive]);

  return (
    <Accordion
      expanded={expand}
      TransitionProps={{ unmountOnExit: true }}
      classes={{
        root: classes.container,
        expanded: classes.expanded,
      }}
    >
      <AccordionSummary
        className="content"
        classes={{ content: classes.content, expanded: classes.expanded }}
        onClick={handleToggleExpand}
      >
        <Box className="progress">
          <CircleChart
            percentage={handleGetProgress('percentage')}
            label={`${lessonsModuleCompleted}`}
            size={32}
          />
        </Box>
        <Box className="text-wrapper">
          <Typography
            variant="body2"
            className={`title ${
              handleGetProgress('percentage') === 100 ? 'completed' : ''
            }`}
          >
            {description}
          </Typography>
          <Typography variant="overline" className="amount">
            {handleGetProgress('phrase')}
          </Typography>
        </Box>
        <Icon className="icon">
          {`keyboard_arrow_${expand ? 'up' : 'down'}`}
        </Icon>
      </AccordionSummary>
      <AccordionDetails className="content-children">
        {children.length > 0 ? (
          children
        ) : (
          <Box className="empty-module">
            <Typography variant="caption" className="empty-module-text">
              Não há aulas disponíveis neste módulo.
            </Typography>
          </Box>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default memo(Module);
